import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button'
import {styles} from '../../CSS/Styles';
import CustomizedTable from '../../CSSComponent/table'
import {KRIAlertChartDataFormationfloodingDetail} from '../../SharedComponents/KRIAlertChartDataFormation'

class predictionTable extends Component {
    constructor(props) {
        super(props)
    }

//
    render() {
        const { classes } = this.props
        if (this.props.date == null) {
            return(<div/>)
        }

        const tableHeaderMap = {
            'Follow Up Action': 'follow_up_action',
            'Staff': 'assigned_user',
            'Date Identified': 'created_date',
            'Timeline': 'due_date'
        }
        const tableHeader = ['location']



        console.log(this.props.date)
        let floodingdetail = KRIAlertChartDataFormationfloodingDetail(this.props.data, this.props.threshold, this.props.date)
        console.log(floodingdetail)
        let tabledata=[]
        for (let j = 0; j < floodingdetail.datasets.length; j++) {
            let obj = {
                location: (floodingdetail.datasets[j]).label.split('.')[1]
            }
            for (let i = 0; i < floodingdetail.labels.length; i++) {
                obj[floodingdetail.labels[i]] = (floodingdetail.datasets[j]).data[i]
                if (j == floodingdetail.datasets.length - 1) {
                    tableHeader.push(floodingdetail.labels[i])
                }
            }
            tabledata.push(obj)
        }
        console.log(tabledata)


        return (
            <CustomizedTable
                preTableText='flooding prediction details'
                tableHeader = {tableHeader}
                data = {tabledata}
            />
        )
    }
}
export default withStyles(styles)(predictionTable)


// WEBPACK FOOTER //
// ./src/components/Dashboard/KRIDashboardComponent/KRIFloodingPredictionDetailtable.js